import React from 'react';
import './News.css';
import newsEvents from '../data/newsEvents';

function News({ language = 'zh' }) {
  return (
    <div className="news-page">
      <div className="news-page-container">
        <header className="news-page-header">
          <h1>{language === 'en' ? 'News' : '新闻'}</h1>
        </header>
        <section className="timeline" aria-label={language === 'en' ? 'News timeline' : '新闻时间线'} lang="zh-CN">
          <div className="timeline-line" aria-hidden="true" />
          {newsEvents.map((item, index) => (
            <article key={item.id} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`} aria-labelledby={`${item.id}-title`}>
              <div className="timeline-marker" aria-hidden="true"><span className="pulse" /></div>
              <div className="timeline-card">
                <div className="timeline-header"><span className="timeline-month">{item.date}</span></div>
                <div className="timeline-media"><img src={item.image} alt={item.title} loading="lazy" decoding="async" /></div>
                <div className="timeline-body">
                  <h2 className="timeline-title" id={`${item.id}-title`}>{item.title}</h2>
                  {item.note && <p className="news-source-note">{item.note}</p>}
                  <p className="timeline-text">{item.body}</p>
                  {item.link && <a className="news-museum-link" href={item.link} target="_blank" rel="noopener noreferrer">{item.linkLabel} <span aria-hidden="true">↗</span></a>}
                </div>
              </div>
            </article>
          ))}
        </section>
        <footer className="game-footer"><div className="footer-text">© {new Date().getFullYear()} Video Game and Art Research Center, Peking University</div></footer>
      </div>
    </div>
  );
}

export default News;
